// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-component-header__title[data-v-6949ffa8]{margin:0;font-family:SFProDisplay-Medium,sans-serif;font-size:21px;line-height:26px}.group-edit[data-v-6949ffa8]{position:fixed;width:100%;height:100%;padding:20px;top:0;left:0;z-index:1002;background:#fff}", ""]);
// Exports
module.exports = exports;
